import * as types from '../actions/types'
import Immutable from 'immutable'

// import { tableCols } from '../containers/Solicitudes'
// const columnas = Immutable.fromJS(tableCols)

const INITIAL_STATE = Immutable.fromJS({
	solicitudes: [],
	page: 1,
	showRecords: 100,
	totalRecords: 0,
	orderBy: {
		field: 'id',
		asc: false
	},
	modalDelete: {
		show: false,
		action: null,
		message: null
	},
	
	// modalFilter: {
	// 	show: false,
	// 	columnas: [],
	// 	filters: []
	// },

	modalFilter: {
		show: false,
		columnas: [],
		filters: [{
			apply : true,
			checked : false,
			column : 'estado',
			comparison : 'string',
			operator : '!==',
			value : '0'
		}]
	},


})

export default function (state = INITIAL_STATE, action) {
	let id
	let index
	const columnas = state.getIn(['modalFilter', 'columnas'])
	switch (action.type) {
		case types.OBTENER_SOLICITUDES:
			state = state.set('solicitudes', Immutable.fromJS(action.payload.data))
			state = state.set('page', action.payload.page)
			state = state.set('totalRecords', action.payload.totalRecords);
			return state
		case types.CONMUTAR_SELECCION_SOLICITUD:
			state = state.setIn(['solicitudes', action.payload.index, 'selected'], action.payload.checked)
			return state
		case types.CONMUTAR_SELECCION_TODOS_SOLICITUDES:
			state.get('solicitudes').forEach((x, n) => {
				if (action.payload) {
					if (x.get('visible')) {
						state = state.setIn(['solicitudes', n, 'selected'], action.payload)
					}
				} else {
					state = state.setIn(['solicitudes', n, 'selected'], action.payload)
				}
			})
			return state
		case types.ORDENAR_SOLICITUDES:
			state = state.set('orderBy', action.payload.orderBy)
			return state
		case types.MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_SOLICITUD:
			state = state.setIn(['modalDelete', 'show'], action.payload.open)
			state = state.setIn(['modalDelete', 'action'], action.payload.action)
			state = state.setIn(['modalDelete', 'message'], action.payload.message)
			return state
		case types.ELIMINAR_SOLICITUD:
			index = state.get('solicitudes').findIndex(x => x.get('id') === action.payload)
			state = state.deleteIn(['solicitudes', index])
			state = state.setIn(['modalDelete', 'show'], false)
			state = state.setIn(['modalDelete', 'action'], null)
			state = state.setIn(['modalDelete', 'message'], null)
			return state
        case types.MOSTRAR_MODAL_CRITERIOS_FILTRADO_SOLICITUDES:
			state = state.setIn(['modalFilter', 'show'], action.payload.state)
			state = state.setIn(['modalFilter', 'columnas'], Immutable.fromJS(action.payload.tableCols))
            return state
		case types.ADICIONAR_CRITERIO_FILTRADO_SOLICITUDES:			
            const firstCol = columnas.first()
            state = state.updateIn(['modalFilter', 'filters'], filter => filter
                .push(Immutable.fromJS({ 
                    column: firstCol.get('value'),
                    operator: '===',
                    value: '',
                    checked: false,
                    comparison: firstCol.get('type'),
                    apply: false
                }))
            )
            return state
        case types.ELIMINAR_CRITERIO_FILTRADO_SOLICITUDES:
            state = state.setIn(['modalFilter', 'filters'], state.getIn(['modalFilter', 'filters']).filter(item => !item.get('checked')))
            return state
        case types.CONMUTAR_SELECCION_CRITERIO_FILTRADO_SOLICITUDES:
            state = state.setIn(['modalFilter', 'filters', action.payload.index, 'checked'], action.payload.checked)
            return state
        case types.MODIFICAR_CRITERIO_FILTRADO_SOLICITUDES:
            if (action.payload.attr === 'column') {
                state = state.setIn(['modalFilter', 'filters', action.payload.index, 'comparison'], columnas.find(x => x.get('value') === action.payload.value).get('type'))
            }
            state = state.setIn(['modalFilter', 'filters', action.payload.index, action.payload.attr], action.payload.value)
            return state
        case types.APLICAR_CRITERIOS_FILTRADO_SOLICITUDES:
            state = state.updateIn(['modalFilter', 'filters'], filter => filter
                .map(x => {
                    x = x.set('apply', true)
                    return x
                })
            )
            return state
		case types.CAMBIAR_MOSTRAR_REGISTROS_SOLICITUDES:
            state = state.set('showRecords', action.payload)
            return state
    	default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/solicitudes.js